'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Padding = exports.Margin = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _spacings = require('../helpers/spacings');

var _breakpoint = require('../config/enums/breakpoint');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};
var Margin = exports.Margin = _styledComponents2.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n\n  margin-right: ", ";\n  margin-left: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n\n  @media (max-width: ", ") {\n    margin-right: ", ";\n    margin-left: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"], ["\n  display: ", ";\n\n  margin-right: ", ";\n  margin-left: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n\n  @media (max-width: ", ") {\n    margin-right: ", ";\n    margin-left: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"])), function (p) {
    return p.inline ? 'inline' : 'block';
}, function (p) {
    return (0, _spacings.getSpacing)(!p.right, p.size, _breakpoint.Breakpoint.WEB);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.left, p.size, _breakpoint.Breakpoint.WEB);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.top, p.size, _breakpoint.Breakpoint.WEB);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.bottom, p.size, _breakpoint.Breakpoint.WEB);
}, _breakpoint.Breakpoint.MOBILE, function (p) {
    return (0, _spacings.getSpacing)(!p.right, p.size, _breakpoint.Breakpoint.MOBILE);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.left, p.size, _breakpoint.Breakpoint.MOBILE);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.top, p.size, _breakpoint.Breakpoint.MOBILE);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.bottom, p.size, _breakpoint.Breakpoint.MOBILE);
});
var Padding = exports.Padding = _styledComponents2.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  padding-right: ", ";\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n\n  @media (max-width: ", ") {\n    padding-right: ", ";\n    padding-left: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n  }\n"], ["\n  width: ", ";\n  padding-right: ", ";\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n\n  @media (max-width: ", ") {\n    padding-right: ", ";\n    padding-left: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n  }\n"])), function (_a) {
    var fullWidth = _a.fullWidth;
    return fullWidth ? '100%' : 'initial';
}, function (p) {
    return (0, _spacings.getSpacing)(!p.right, p.size, _breakpoint.Breakpoint.WEB);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.left, p.size, _breakpoint.Breakpoint.WEB);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.top, p.size, _breakpoint.Breakpoint.WEB);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.bottom, p.size, _breakpoint.Breakpoint.WEB);
}, _breakpoint.Breakpoint.MOBILE, function (p) {
    return (0, _spacings.getSpacing)(!p.right, p.size, _breakpoint.Breakpoint.MOBILE);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.left, p.size, _breakpoint.Breakpoint.MOBILE);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.top, p.size, _breakpoint.Breakpoint.MOBILE);
}, function (p) {
    return (0, _spacings.getSpacing)(!p.bottom, p.size, _breakpoint.Breakpoint.MOBILE);
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=spacings.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/styles/spacings.js
// module id = 303
// module chunks = 0